import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Project } from '../projects/domain/project';
import { PhaseWithEmployees } from '../projects/domain/phase-with-employees';

@Injectable({
  providedIn: 'root',
})
export class RecommendEmployeeService {
  private project = new BehaviorSubject<Project | undefined>(undefined);
  private phase = new BehaviorSubject<PhaseWithEmployees | undefined>(undefined);

  phase$ = this.phase.asObservable();

  constructor(private httpClient: HttpClient) {}

  setProject(project: Project): void {
    this.project.next(project);
  }

  setPhase(phase: PhaseWithEmployees): void {
    this.phase.next(phase);
  }

  recommendEmployeeToPhase(employeeIds: string[], projectId: string, phaseId: string): Observable<any> {
    const employees = employeeIds.map((id) => ({ employeeId: id }));
    return this.httpClient.post(`${environment.api}/project/${projectId}/phase/${phaseId}/recommend-employee`, {
      employees
    });
  }

  removeRecommendedEmployeeFromPhase(employeeOnPhaseIds: string[], projectId: string, phaseId: string): Observable<any> {
    return this.httpClient.delete(`${environment.api}/project/${projectId}/phase/${phaseId}/recommended-employee`, {
      body: { ids: employeeOnPhaseIds }
    });
  }

  acceptRecommendedEmployeeToPhase(employeeIds: string[], projectId: string, phaseId: string): Observable<any> {
    return this.httpClient.post(`${environment.api}/project/${projectId}/phase/${phaseId}/recommended-employee/approve`, {
      employeeIds
    });
  }

  addRecommendedEmployeeInPhaseNote(employeeOnPhaseId: string, projectId: string, phaseId: string, note: string): Observable<any> {
    return this.httpClient.post(`${environment.api}/project/${projectId}/phase/${phaseId}/recommended-employee/${employeeOnPhaseId}/note`,{
      note
    });
  }

  editRecommendedEmployeeInPhaseNote(employeeOnPhaseId: string, projectId: string, phaseId: string, noteId: string, note: string): Observable<any> {
    return this.httpClient.put(`${environment.api}/project/${projectId}/phase/${phaseId}/recommended-employee/${employeeOnPhaseId}/note/${noteId}`,{
      note
    });
  }

  removeRecommendedEmployeeInPhaseNote(employeeOnPhaseId: string, projectId: string, phaseId: string, noteId: string): Observable<any> {
    return this.httpClient.delete(`${environment.api}/project/${projectId}/phase/${phaseId}/recommended-employee/${employeeOnPhaseId}/note/${noteId}`);
  }
}
